import { CfsRequestByDroOpts } from "presentation/constant/DropDownOptions/Charge/CfsRequestByDroOpts";
import { ActiveIndDroOpts } from "presentation/constant/DropDownOptions/Common/ActiveIndDroOpts";
import { cntrTspStatusDropdownOption, directDischargeIndValDropdownOption, operationTypeDropdownOption, rcTypeDropdownOption, reeferHandlingTypeDropdownOption, statusDropdownOptions, tariffMappingCntrTspStatusDropdownOption, tariffSettingBundleIndDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { TariffMappingConstant, tariffMappingRequiredFieldList } from "presentation/constant/TariffMapping/TariffMappingConstant";
import { useTariffMappingVM } from "presentation/hook/TariffMapping/useTariffMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useTariffMappingTracked } from "presentation/store/TariffMapping/TariffMappingProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, HPHGroupTitle, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const TariffMappingEditPanel = () => {
    const TARIFF_MAPPING_CONSTANT = TariffMappingConstant.Table;
    const [isLoading, setIsLoading] = useState(false);
    const [tariffMappingState] = useTariffMappingTracked();
    const tariffMappingVM = useTariffMappingVM();
    const { currentEditRow, isAdd, isEdit, masterState } = tariffMappingState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit, allowUpdate } = anainfoState;


    const handleSave = useCallback(async () => {
        // if (!currentEditRow.tariffType) {
        //     messageBarVM.showError("Tariff Type is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.tariffCode) {
        //     messageBarVM.showError("Tariff Code is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.chargeType) {
        //     messageBarVM.showError("Charge Type is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        // if (currentEditRow.loaLimitFrom && (currentEditRow.loaLimitFrom < 0 || currentEditRow.loaLimitFrom > 9999999.99)) {
        //     messageBarVM.showError("Input Loa Limit From Value should be range from 0 to 9999999.99.");
        //     return;
        // }
        // if (currentEditRow.loaLimitTo && (currentEditRow.loaLimitTo < 0 || currentEditRow.loaLimitTo > 9999999.99)) {
        //     messageBarVM.showError("Input Loa Limit To Value should be range from 0 to 9999999.99.");
        //     return;
        // }
        // if (currentEditRow.overWeightFrom && (currentEditRow.overWeightFrom < 0 || currentEditRow.overWeightFrom > 9999999.99)) {
        //     messageBarVM.showError("Input Over Weight From Value should be range from 0 to 9999999.99.");
        //     return;
        // }
        // if (currentEditRow.overWeightTo && (currentEditRow.overWeightTo < 0 || currentEditRow.overWeightTo > 9999999.99)) {
        //     messageBarVM.showError("Input Over Weight To Value should be range from 0 to 9999999.99.");
        //     return;
        // }
        if (currentEditRow.loaLimitFrom && currentEditRow.loaLimitTo && (Number(currentEditRow.loaLimitTo) < Number(currentEditRow.loaLimitFrom))) {
            messageBarVM.showError("LOA Limit From should be smaller than LOA Limit To.");
            return;
        }
        if (currentEditRow.overWeightFrom && currentEditRow.overWeightTo && (Number(currentEditRow.overWeightTo) < Number(currentEditRow.overWeightFrom))) {
            messageBarVM.showError("Over Weight From should be smaller than Over Weight To.");
            return;
        }
        if (currentEditRow.vesselWeightFrom && currentEditRow.vesselWeightTo && (Number(currentEditRow.vesselWeightTo) < Number(currentEditRow.vesselWeightFrom))) {
            messageBarVM.showError("Vessel Weight From should be smaller than Vessel Weight To.");
            return;
        }
        setIsLoading(true);
        tariffMappingVM.onSaveClicked();
        const data = await tariffMappingVM.onSave(currentEditRow);
        if (data && data.success) {
            messageBarVM.showSuccess("Save Successfully.");
            tariffMappingVM.searchAllTariffMappingList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        } else {
            setIsLoading(false)
            data.data && messageBarVM.showError(data.data);
            return;
        }
    }, [tariffMappingVM, currentEditRow, messageBarVM]);

    const handClose = useCallback(() => {
        tariffMappingVM.onCloseEidtPanel();
    }, [tariffMappingVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        tariffMappingVM.onHeaderFieldChange(fieldName, fieldValue);
    }, [tariffMappingVM]);

    const memoSubChgTypeOptions = useMemo(() => {
        const subChgTypeOptions = currentEditRow.chargeType ? tariffMappingState.dynamicOptions.subChargeTypeDropdownOptions[currentEditRow.chargeType] : [];
        return subChgTypeOptions;
    }, [currentEditRow.chargeType, tariffMappingState.dynamicOptions.subChargeTypeDropdownOptions])

    const memoTariffCodeOptions = useMemo(() => {
        return currentEditRow.tariffType
            ? tariffMappingState.dynamicOptions.tariffCodeDropdownOptions[currentEditRow.tariffType]
            : [];
    }, [currentEditRow.tariffType, tariffMappingState.dynamicOptions.tariffCodeDropdownOptions]);

    const memoSubServiceReqCodeOptions = useMemo(() => {
        const subServiceReqCodeOptions = currentEditRow.serviceRequestCode ? tariffMappingState.dynamicOptions.subServiceReqCodeDropdownOptions[currentEditRow.serviceRequestCode] : [];
        return subServiceReqCodeOptions;
    }, [currentEditRow.serviceRequestCode, tariffMappingState.dynamicOptions.subServiceReqCodeDropdownOptions])

    const memoAllSubServiceReqCodeOptions = useMemo(() => {
        const flattenedSubChgOptions = Object.values(tariffMappingState.dynamicOptions.subServiceReqCodeDropdownOptions ?? {}).flat();
        const uniqueSubChgOptions = Array.from(
            new Map(flattenedSubChgOptions.map(option => [option.value, option])).values()
        );
        return uniqueSubChgOptions;
    }, [tariffMappingState.dynamicOptions.subServiceReqCodeDropdownOptions]);


    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEditRow?.chargeType || ''}
                fieldValue={currentEditRow?.chargeType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, currentEditRow?.chargeType, TARIFF_MAPPING_CONSTANT.CHARGE_TYPE, isSaveClicked, tariffMappingState.dynamicOptions.chargeTypeDropdownOptions, tariffMappingVM])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.subChargeType || ''}
                fieldValue={currentEditRow?.subChargeType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeType'}
                maxLength={60}
                options={memoSubChgTypeOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.subChargeType, TARIFF_MAPPING_CONSTANT.SUB_CHARGE_TYPE, isSaveClicked, memoSubChgTypeOptions, tariffMappingVM])

    const memoOpsLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.opsLine || ''}
                fieldValue={currentEditRow?.opsLine}
                fieldLabel={TARIFF_MAPPING_CONSTANT.OPS_LINE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'opsLine'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.opsLineDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.opsLine, TARIFF_MAPPING_CONSTANT.OPS_LINE, isSaveClicked, tariffMappingState.dynamicOptions.opsLineDropdownOptions, tariffMappingVM])

    const memoChargeOnCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeOnCompanyCode || ''}
                fieldValue={currentEditRow?.chargeOnCompanyCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CHARGEON_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeOnCompanyCode'}
                maxLength={60}
                sort={false}
                isLimitOptions={true}
                options={tariffMappingState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.chargeOnCompanyCode, TARIFF_MAPPING_CONSTANT.CHARGEON_COMPANY, isSaveClicked, tariffMappingState.dynamicOptions.companyCodeDropdownOptions, tariffMappingVM])


    const memoSize = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cntrSize || ''}
                fieldValue={currentEditRow?.cntrSize}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SIZE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrSize'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.cntrSizeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.cntrSize, TARIFF_MAPPING_CONSTANT.SIZE, isSaveClicked, tariffMappingState.dynamicOptions.cntrSizeDropdownOptions, tariffMappingVM])

    const memoCntrType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cntrType || ''}
                fieldValue={currentEditRow?.cntrType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrType'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.cntrTypeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.cntrType, TARIFF_MAPPING_CONSTANT.TYPE, isSaveClicked, tariffMappingState.dynamicOptions.cntrTypeDropdownOptions, tariffMappingVM])

    const memoCntrTypeGroup = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cntrTypeGroup || ''}
                fieldValue={currentEditRow?.cntrTypeGroup}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CNTR_TYPE_GROUP}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrTypeGroup'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.cntrTypeGroupDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.cntrTypeGroup, TARIFF_MAPPING_CONSTANT.CNTR_TYPE_GROUP, isSaveClicked, tariffMappingState.dynamicOptions.cntrTypeGroupDropdownOptions, tariffMappingVM])

    const memoCntrStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cntrStatus || ''}
                fieldValue={currentEditRow?.cntrStatus}
                fieldLabel={TARIFF_MAPPING_CONSTANT.STATUS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrStatus'}
                maxLength={60}
                options={statusDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.cntrStatus, TARIFF_MAPPING_CONSTANT.STATUS, isSaveClicked, tariffMappingVM])

    const memoShipmentType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.shipmentType || ''}
                fieldValue={currentEditRow?.shipmentType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SHIPMENT_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shipmentType'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.shipmentTypeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.shipmentType, TARIFF_MAPPING_CONSTANT.SHIPMENT_TYPE, isSaveClicked, tariffMappingState.dynamicOptions.shipmentTypeDropdownOptions, tariffMappingVM])

    const memoServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.serviceCode || ''}
                fieldValue={currentEditRow?.serviceCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SERVICE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'serviceCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.serviceCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.serviceCode, TARIFF_MAPPING_CONSTANT.SERVICE_CODE, isSaveClicked, tariffMappingState.dynamicOptions.serviceCodeDropdownOptions, tariffMappingVM])

    const memoModalityOfArrival = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.modalityOfArrival || ''}
                fieldValue={currentEditRow?.modalityOfArrival}
                fieldLabel={TARIFF_MAPPING_CONSTANT.MODALITY_OF_ARRIVAL}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'modalityOfArrival'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.modalityDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.modalityOfArrival, TARIFF_MAPPING_CONSTANT.MODALITY_OF_ARRIVAL, isSaveClicked, tariffMappingState.dynamicOptions.modalityDropdownOptions, tariffMappingVM])

    const memoModalityOfDeparture = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.modalityOfDeparture || ''}
                fieldValue={currentEditRow?.modalityOfDeparture}
                fieldLabel={TARIFF_MAPPING_CONSTANT.MODALITY_OF_DEPARTURE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'modalityOfDeparture'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.modalityDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.modalityOfDeparture, TARIFF_MAPPING_CONSTANT.MODALITY_OF_DEPARTURE, isSaveClicked, tariffMappingState.dynamicOptions.modalityDropdownOptions, tariffMappingVM])

    const memoMarshalFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.marshallingFrom || ''}
                fieldValue={currentEditRow?.marshallingFrom}
                fieldLabel={TARIFF_MAPPING_CONSTANT.MARSHALLING_FROM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'marshallingFrom'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.marshalCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.marshallingFrom, TARIFF_MAPPING_CONSTANT.MARSHALLING_FROM, isSaveClicked, tariffMappingState.dynamicOptions.marshalCodeDropdownOptions, tariffMappingVM])

    const memoMarshalTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.marshallingTo || ''}
                fieldValue={currentEditRow?.marshallingTo}
                fieldLabel={TARIFF_MAPPING_CONSTANT.MARSHALLING_TO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'marshallingTo'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.marshalCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.marshallingTo, TARIFF_MAPPING_CONSTANT.MARSHALLING_TO, isSaveClicked, tariffMappingState.dynamicOptions.marshalCodeDropdownOptions, tariffMappingVM])

    const memoServiceRequestCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.serviceRequestCode || ''}
                fieldValue={currentEditRow?.serviceRequestCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SERVICE_REQUEST_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'serviceRequestCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.serviceReqCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
                    if (currentEditRow?.serviceRequestCode !== fieldValue) {
                        tariffMappingVM.onHeaderFieldChange('subServiceRequestCode', null, null);
                    }
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue);
                }} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.serviceRequestCode, TARIFF_MAPPING_CONSTANT.SERVICE_REQUEST_CODE, isSaveClicked, tariffMappingState.dynamicOptions.serviceReqCodeDropdownOptions, tariffMappingVM])

    const memoSubServiceRequestCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.subServiceRequestCode || ''}
                fieldValue={currentEditRow?.subServiceRequestCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SUB_SERVICE_REQUEST_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subServiceRequestCode'}
                maxLength={60}
                options={!currentEditRow?.serviceRequestCode && (operatingUnit === 'OICT' || operatingUnit === 'HPJZ') ? memoAllSubServiceReqCodeOptions : memoSubServiceReqCodeOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.serviceRequestCode, currentEditRow?.subServiceRequestCode, TARIFF_MAPPING_CONSTANT.SUB_SERVICE_REQUEST_CODE, isSaveClicked, memoSubServiceReqCodeOptions, memoAllSubServiceReqCodeOptions, operatingUnit, tariffMappingVM])


    const memoWireSlingInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.wireSlingInd || ''}
                fieldValue={currentEditRow?.wireSlingInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.WIRE_SLING_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'wireSlingInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.wireSlingInd, TARIFF_MAPPING_CONSTANT.WIRE_SLING_IND, isSaveClicked, tariffMappingVM])



    const memoMarshallingType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.marshallingType || ''}
                fieldValue={currentEditRow?.marshallingType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.MARSHALLING_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'marshallingType'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.marshallingTypeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.marshallingType, TARIFF_MAPPING_CONSTANT.MARSHALLING_TYPE, isSaveClicked, tariffMappingState.dynamicOptions.marshallingTypeDropdownOptions, tariffMappingVM])

    const memoChargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeInd || ''}
                fieldValue={currentEditRow?.chargeInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CHARGE_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeInd'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.chargeIndDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.chargeInd, TARIFF_MAPPING_CONSTANT.CHARGE_IND, isSaveClicked, tariffMappingState.dynamicOptions.chargeIndDropdownOptions, tariffMappingVM])

    const memoSpecialHandlingInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.specialHandlingInd || ''}
                fieldValue={currentEditRow?.specialHandlingInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SP_HANDLING_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'specialHandlingInd'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.specHandingIndDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.specialHandlingInd, TARIFF_MAPPING_CONSTANT.SP_HANDLING_IND, isSaveClicked, tariffMappingState.dynamicOptions.specHandingIndDropdownOptions, tariffMappingVM])

    const memoLiftOnOffInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.liftOnOffInd || ''}
                fieldValue={currentEditRow?.liftOnOffInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.LIFT_ON_OFF_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'liftOnOffInd'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.liftOnOffIndDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.liftOnOffInd, TARIFF_MAPPING_CONSTANT.LIFT_ON_OFF_IND, isSaveClicked, tariffMappingState.dynamicOptions.liftOnOffIndDropdownOptions, tariffMappingVM])

    const memoBundleInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.bundleInd || ''}
                fieldValue={currentEditRow?.bundleInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.BUNDLE_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'bundleInd'}
                maxLength={60}
                options={tariffSettingBundleIndDropdownOption}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.bundleInd, TARIFF_MAPPING_CONSTANT.BUNDLE_IND, isSaveClicked, tariffMappingVM])


    const memoTspStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cntrTspStatus || ''}
                fieldValue={currentEditRow?.cntrTspStatus}
                fieldLabel={TARIFF_MAPPING_CONSTANT.TRANSPORTATION_STATUS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrTspStatus'}
                maxLength={60}
                options={(operatingUnit === 'OICT' || operatingUnit === 'HPJZ') ? tariffMappingCntrTspStatusDropdownOption : cntrTspStatusDropdownOption}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.cntrTspStatus, TARIFF_MAPPING_CONSTANT.TRANSPORTATION_STATUS, isSaveClicked, tariffMappingVM, operatingUnit])



    const memoOperationType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.operationType || ''}
                fieldValue={currentEditRow?.operationType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.OPERATION_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operationType'}
                maxLength={60}
                options={operationTypeDropdownOption}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.operationType, TARIFF_MAPPING_CONSTANT.OPERATION_TYPE, isSaveClicked, tariffMappingVM])

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow?.tariffType || ''}
                fieldValue={currentEditRow?.tariffType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.TARIFF_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                options={tariffMappingState.dynamicOptions.tariffTypeDropdownOptions}
                maxLength={60}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.TARIFF_TYPE, allFormState, currentEditRow?.tariffType, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.tariffTypeDropdownOptions, tariffMappingVM])

    const memoTariffCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.tariffCode || ''}
                fieldValue={currentEditRow?.tariffCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.TARIFF_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffCode'}
                options={memoTariffCodeOptions}
                maxLength={60}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.TARIFF_CODE, allFormState, currentEditRow?.tariffCode, isAdd, isEdit, isSaveClicked, memoTariffCodeOptions, tariffMappingVM])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={[]}
                fieldLabel={TARIFF_MAPPING_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => tariffMappingVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [TARIFF_MAPPING_CONSTANT.ACTIVE_IND, tariffMappingVM, currentEditRow?.activeInd, isAdd, isEdit])

    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.forwarderCode || ''}
                fieldValue={currentEditRow?.forwarderCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.FORWARDER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'forwarderCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.forwarderCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.FORWARDER_CODE, allFormState, currentEditRow?.forwarderCode, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.forwarderCodeDropdownOptions, tariffMappingVM])
    const memoForwarderReference = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.forwarderRef || ''}
                fieldValue={currentEditRow?.forwarderRef}
                fieldLabel={TARIFF_MAPPING_CONSTANT.FORWARDER_REF}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderRef'}
                maxLength={50}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString().toUpperCase(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.FORWARDER_REF, allFormState, currentEditRow?.forwarderRef, isAdd, isEdit, isSaveClicked, tariffMappingVM])

    const memoPhysicalHandlingCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.physicalHandlingCode || ''}
                fieldValue={currentEditRow?.physicalHandlingCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CONTAINER_PHYSICAL_HANDLING_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'physicalHandlingCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.physicalHandlingCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.CONTAINER_PHYSICAL_HANDLING_CODE, allFormState, currentEditRow?.physicalHandlingCode, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.physicalHandlingCodeDropdownOptions, tariffMappingVM])

    const memoConsortiumCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.consortiumCode || ''}
                fieldValue={currentEditRow?.consortiumCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CONSORTIUM_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'consortiumCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.consortiumCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.CONSORTIUM_CODE, allFormState, currentEditRow?.consortiumCode, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.consortiumCodeDropdownOptions, tariffMappingVM])

    const memoLoaLimitFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NumberInputComponent
                label={TARIFF_MAPPING_CONSTANT.LOA_LIMIT_FROM}
                maxLength={10}
                fieldName={"loaLimitFrom"}
                value={currentEditRow?.loaLimitFrom ?? ''}
                errorMessage={''}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [TARIFF_MAPPING_CONSTANT.LOA_LIMIT_FROM, currentEditRow?.loaLimitFrom, isAdd, isEdit, onNumberFieldChange])

    const memoLoaLimitTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NumberInputComponent
                label={TARIFF_MAPPING_CONSTANT.LOA_LIMIT_TO}
                maxLength={10}
                fieldName={"loaLimitTo"}
                value={currentEditRow?.loaLimitTo ?? ''}
                errorMessage={''}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [TARIFF_MAPPING_CONSTANT.LOA_LIMIT_TO, currentEditRow?.loaLimitTo, isAdd, isEdit, onNumberFieldChange])

    const memoDirectInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.directInd || ''}
                fieldValue={currentEditRow?.directInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.DIRECT_DISCHARGE_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'directInd'}
                maxLength={60}
                options={directDischargeIndValDropdownOption}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.DIRECT_DISCHARGE_IND, allFormState, currentEditRow?.directInd, isAdd, isEdit, isSaveClicked, tariffMappingVM])

    const memoReeferHandlingType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.reeferHandlingType || ''}
                fieldValue={currentEditRow?.reeferHandlingType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.REEFER_HANDLING_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'reeferHandlingType'}
                maxLength={60}
                options={reeferHandlingTypeDropdownOption}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.REEFER_HANDLING_TYPE, allFormState, currentEditRow?.reeferHandlingType, isAdd, isEdit, isSaveClicked, tariffMappingVM])

    const memoServiceOrderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.serviceOrderCode || ''}
                fieldValue={currentEditRow?.serviceOrderCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SERVICE_ORDER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'serviceOrderCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.serviceOrderCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.SERVICE_ORDER_CODE, allFormState, currentEditRow?.serviceOrderCode, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.serviceOrderCodeDropdownOptions, tariffMappingVM])

    const memoOverWeightFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NumberInputComponent
                label={TARIFF_MAPPING_CONSTANT.OVER_WEIGHT_FROM}
                maxLength={10}
                fieldName={"overWeightFrom"}
                value={currentEditRow?.overWeightFrom ?? ''}
                errorMessage={''}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [TARIFF_MAPPING_CONSTANT.OVER_WEIGHT_FROM, currentEditRow?.overWeightFrom, isAdd, isEdit, onNumberFieldChange])

    const memoOverWeightTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NumberInputComponent
                label={TARIFF_MAPPING_CONSTANT.OVER_WEIGHT_TO}
                maxLength={10}
                fieldName={"overWeightTo"}
                value={currentEditRow?.overWeightTo ?? ''}
                errorMessage={''}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [TARIFF_MAPPING_CONSTANT.OVER_WEIGHT_TO, currentEditRow?.overWeightTo, isAdd, isEdit, onNumberFieldChange])

    const memoCargoType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cargoType || ''}
                fieldValue={currentEditRow?.cargoType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CARGO_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cargoType'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.cargoTypeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.CARGO_TYPE, allFormState, currentEditRow?.cargoType, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.cargoTypeDropdownOptions, tariffMappingVM])

    const memoCargoCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cargoCode || ''}
                fieldValue={currentEditRow?.cargoCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CARGO_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cargoCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.cargoCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.CARGO_CODE, allFormState, currentEditRow?.cargoCode, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.cargoCodeDropdownOptions, tariffMappingVM])


    const memoSpecialArea = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.specialArea || ''}
                fieldValue={currentEditRow?.specialArea}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SPECIAL_AREA}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'specialArea'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.specialAreaDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.SPECIAL_AREA, allFormState, currentEditRow?.specialArea, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.specialAreaDropdownOptions, tariffMappingVM])

    const memoPalletizedInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.palletizedInd || ''}
                fieldValue={currentEditRow?.palletizedInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.PALLETIZED_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'palletizedInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.PALLETIZED_IND, allFormState, currentEditRow?.palletizedInd, isAdd, isEdit, isSaveClicked, tariffMappingVM])

    const memoRoundTrip = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.roundTripFlag || ''}
                fieldValue={currentEditRow?.roundTripFlag}
                fieldLabel={TARIFF_MAPPING_CONSTANT.ROUND_TRIP}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'roundTripFlag'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.ROUND_TRIP, allFormState, currentEditRow?.roundTripFlag, isAdd, isEdit, isSaveClicked, tariffMappingVM])

    const memoSpecialInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.specialInd || ''}
                fieldValue={currentEditRow?.specialInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SPECIAL_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'specialInd'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.specialIndDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.SPECIAL_IND, allFormState, currentEditRow?.specialInd, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.specialIndDropdownOptions, tariffMappingVM])

    const memoTsLegChargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.tsLegChargeInd || ''}
                fieldValue={currentEditRow?.tsLegChargeInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.TRANSHIPMENT_LEG_CHARGE_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tsLegChargeInd'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.transhipmentLegChargeIndDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.TRANSHIPMENT_LEG_CHARGE_IND, allFormState, currentEditRow?.tsLegChargeInd, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.transhipmentLegChargeIndDropdownOptions, tariffMappingVM])

    const memoOverWeightInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.overWeightInd || ''}
                fieldValue={currentEditRow?.overWeightInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.OVER_WIDTH_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'overWeightInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.OVER_WIDTH_IND, allFormState, currentEditRow?.overWeightInd, isAdd, isEdit, isSaveClicked, tariffMappingVM])



    const memoOverDimensionInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.overDimensionInd || ''}
                fieldValue={currentEditRow?.overDimensionInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.OVER_DIMENSION_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'overDimensionInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.OVER_DIMENSION_IND, allFormState, currentEditRow?.overDimensionInd, isAdd, isEdit, isSaveClicked, tariffMappingVM])


    const memoEmptyIndicator = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.emptyIndicator || ''}
                fieldValue={currentEditRow?.emptyIndicator}
                fieldLabel={TARIFF_MAPPING_CONSTANT.EMPTY_INDICATOR}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'emptyIndicator'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.EMPTY_INDICATOR, allFormState, currentEditRow?.emptyIndicator, isAdd, isEdit, isSaveClicked, tariffMappingVM])


    const memoNonCellularVslInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.nonCellularVslInd || ''}
                fieldValue={currentEditRow?.nonCellularVslInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.NONCELLULAR_VSL_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'nonCellularVslInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.NONCELLULAR_VSL_IND, allFormState, currentEditRow?.nonCellularVslInd, isAdd, isEdit, isSaveClicked, tariffMappingVM])

    const memoEquipmentCodeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.equipmentCodeInd || ''}
                fieldValue={currentEditRow?.equipmentCodeInd}
                fieldLabel={TARIFF_MAPPING_CONSTANT.EQUIPMENT_CODE_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'equipmentCodeInd'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.equipmentCodeIndDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.EQUIPMENT_CODE_IND, allFormState, currentEditRow?.equipmentCodeInd, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.equipmentCodeIndDropdownOptions, tariffMappingVM])


    const memoShiftCodeOps = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.shiftCodeOps || ''}
                fieldValue={currentEditRow?.shiftCodeOps}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SHIFT_CODEOPS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shiftCodeOps'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.shiftCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.SHIFT_CODEOPS, allFormState, currentEditRow?.shiftCodeOps, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.shiftCodeDropdownOptions, tariffMappingVM])


    const memoRcType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.rcType || ''}
                fieldValue={currentEditRow?.rcType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.REHANDLING_CANCEL_SHIP_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'rcType'}
                maxLength={60}
                options={rcTypeDropdownOption}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.REHANDLING_CANCEL_SHIP_TYPE, allFormState, currentEditRow?.rcType, isAdd, isEdit, isSaveClicked, tariffMappingVM])


    const memoPartnerCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.partnerCode || ''}
                fieldValue={currentEditRow?.partnerCode}
                fieldLabel={TARIFF_MAPPING_CONSTANT.PARTNER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'partnerCode'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.PARTNER_CODE, allFormState, currentEditRow?.partnerCode, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.companyCodeDropdownOptions, tariffMappingVM])

    const memoSoa = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.soa || ''}
                fieldValue={currentEditRow?.soa}
                fieldLabel={TARIFF_MAPPING_CONSTANT.SOA}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'soa'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.soaDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.soa, TARIFF_MAPPING_CONSTANT.SOA, isSaveClicked, tariffMappingVM, tariffMappingState.dynamicOptions.soaDropdownOptions])

    const memoMovementType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.movementType || ''}
                fieldValue={currentEditRow?.movementType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.MOVEMENT_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'movementType'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.moveMentTypeDropdownOptions}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.movementType, TARIFF_MAPPING_CONSTANT.MOVEMENT_TYPE, isSaveClicked, tariffMappingVM, tariffMappingState.dynamicOptions.moveMentTypeDropdownOptions])

    const memoVesselWeightFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NumberInputComponent
                label={TARIFF_MAPPING_CONSTANT.VESSEL_WEIGHT_FROM}
                maxLength={10}
                fieldName={"vesselWeightFrom"}
                value={currentEditRow?.vesselWeightFrom ?? ''}
                errorMessage={''}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [TARIFF_MAPPING_CONSTANT.VESSEL_WEIGHT_FROM, currentEditRow?.vesselWeightFrom, isAdd, isEdit, onNumberFieldChange])

    const memoVesselWeightTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NumberInputComponent
                label={TARIFF_MAPPING_CONSTANT.VESSEL_WEIGHT_TO}
                maxLength={10}
                fieldName={"vesselWeightTo"}
                value={currentEditRow?.vesselWeightTo ?? ''}
                errorMessage={''}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [TARIFF_MAPPING_CONSTANT.VESSEL_WEIGHT_TO, currentEditRow?.vesselWeightTo, isAdd, isEdit, onNumberFieldChange])

    const memoCfsRequestBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cfsBy || ''}
                fieldValue={currentEditRow?.cfsBy}
                fieldLabel={TARIFF_MAPPING_CONSTANT.CFS_REQUEST_BY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cfsBy'}
                maxLength={60}
                options={CfsRequestByDroOpts().getCfsRequestByModel()}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.CFS_REQUEST_BY, allFormState, currentEditRow?.cfsBy, isAdd, isEdit, isSaveClicked, tariffMappingVM])

    const memoMarshalLocationType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.marshalLocationType || ''}
                fieldValue={currentEditRow?.marshalLocationType}
                fieldLabel={TARIFF_MAPPING_CONSTANT.LOCATION_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'marshalLocationType'}
                maxLength={60}
                options={tariffMappingState.dynamicOptions.locationTypeDropdownOption}
                requiredFieldList={tariffMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    tariffMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [TARIFF_MAPPING_CONSTANT.LOCATION_TYPE, allFormState, currentEditRow?.marshalLocationType, isAdd, isEdit, isSaveClicked, tariffMappingState.dynamicOptions.locationTypeDropdownOption, tariffMappingVM])


    const handleEdit = useCallback(() => {
        tariffMappingVM.onEditClick();
    }, [tariffMappingVM]);

    const handleReset = useCallback(() => {
        tariffMappingVM.onResetClick(isAdd);
    }, [tariffMappingVM, isAdd]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: TariffMappingConstant.Title.CATEGORY },
                    { title: TariffMappingConstant.Title.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && !(isAdd || isEdit) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}
                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 105px)', maxHeight: 'calc(100vh - 105px)', overflow: 'visible', zIndex: '99' }}>
                <div className="flex-row-auto" style={{ overflow: 'visible', zIndex: '100' }}>
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Tariff Setting"}
                                    {!isAdd && (currentEditRow.priority + "/" + currentEditRow.tariffType + "/" + currentEditRow.tariffCode)}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>
                        <br />
                        <HPHGroupTitle titleText={TariffMappingConstant.Title.MAPPING_FROM} />
                        <CriteriaItemContainer>
                            {memoChargeType}
                            {memoSubChargeType}
                            {memoChargeOnCompany}
                            {memoOpsLine}
                        </CriteriaItemContainer>
                        <label>CONTAINER</label>
                        <CriteriaItemContainer>
                            {memoSize}
                            {memoCntrStatus}
                            {memoCntrType}
                            {memoCntrTypeGroup}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoShipmentType}
                            {memoPhysicalHandlingCode}
                            {memoForwarderCode}
                            {memoForwarderReference}
                        </CriteriaItemContainer>
                        {(operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && <>
                            <CriteriaItemContainer>
                                {memoCfsRequestBy}
                            </CriteriaItemContainer>

                        </>}

                        <CriteriaItemContainer>
                            {memoConsortiumCode}
                            {memoServiceCode}
                            {memoLoaLimitFrom}
                            {memoLoaLimitTo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoModalityOfArrival}
                            {memoModalityOfDeparture}
                            {memoReeferHandlingType}
                            {memoMarshallingType}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoMarshalFrom}
                            {memoMarshalTo}
                            {(operatingUnit !== 'AQCT' && operatingUnit !== 'RSCT') && <>
                                {memoServiceRequestCode}
                                {memoSubServiceRequestCode}
                            </>}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoOverWeightFrom}
                            {memoOverWeightTo}
                            {memoDirectInd}
                            {memoWireSlingInd}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoLiftOnOffInd}
                            {(operatingUnit === 'OICT' || operatingUnit === 'HPJZ' || operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && <>
                                {memoSoa}
                                {memoMovementType}
                                {memoVesselWeightFrom}
                            </>}
                        </CriteriaItemContainer>
                        {(operatingUnit === 'OICT' || operatingUnit === 'HPJZ' || operatingUnit === 'AQCT' || operatingUnit === 'RSCT') &&
                            <CriteriaItemContainer>
                                {memoVesselWeightTo}
                                {(operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && memoMarshalLocationType}
                            </CriteriaItemContainer>
                        }

                        <label>OTHERS</label>
                        <CriteriaItemContainer>
                            {memoCargoType}
                            {memoCargoCode}
                            {memoServiceOrderCode}
                            {memoPalletizedInd}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoSpecialArea}
                            {memoSpecialInd}
                            {memoChargeInd}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoSpecialHandlingInd}
                            {memoTsLegChargeInd}
                            {memoOverWeightInd}
                            {memoOverDimensionInd}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoEquipmentCodeInd}
                            {memoShiftCodeOps}
                            {memoBundleInd}
                            {memoNonCellularVslInd}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoRcType}
                            {memoPartnerCode}
                            {memoTspStatus}
                            {memoEmptyIndicator}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {(operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') && memoOperationType}
                            {memoRoundTrip}
                        </CriteriaItemContainer>

                        <HPHGroupTitle titleText={TariffMappingConstant.Title.MAPPING_TO} />
                        <CriteriaItemContainer>
                            {memoTariffType}
                            {memoTariffCode}
                            {memoActiveInd}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default memo(TariffMappingEditPanel);
